import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHouseFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1947 2.74807C12.9134 1.75064 11.0866 1.75064 9.80527 2.74807L4.30527 7.02937C3.47995 7.67182 3 8.6412 3 9.66574V17.6156C3 19.4847 4.567 21 6.5 21H17.5C19.433 21 21 19.4847 21 17.6156V9.66574C21 8.6412 20.5201 7.67182 19.6947 7.02937L14.1947 2.74807ZM12 12.2969C9.79086 12.2969 8 14.0286 8 16.1648V20.9997H9V16.1648C9 14.5626 10.3431 13.2638 12 13.2638C13.6569 13.2638 15 14.5626 15 16.1648V20.9997H16V16.1648C16 14.0286 14.2091 12.2969 12 12.2969Z"
        fill="#0C1C43"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(SvgHouseFilled);
export default ForwardRef;
